import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  [ORDER_FULFILLMENT_STATUSES.REJECTED]: 'Annullato',
  [ORDER_FULFILLMENT_STATUSES.CREATED]: 'Ricevuto',
  [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: 'Confermato',
  [ORDER_FULFILLMENT_STATUSES.PREPARING]: 'In preparazione',
  [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: 'In viaggio',
  [ORDER_FULFILLMENT_STATUSES.READY]: 'Pronto',
  status: {
    actual: 'Attuale',
    pending: 'In attesa',
  },
  warning_label: {
    pickup_time_changed: "{{company}} ha modificato l'orario da {{initialTime}} a {{currentTime}}",
  },
  labels: {
    order_number: 'N. ordine: {{number}}',
    today: 'Oggi',
  },
};
